import api from "../api";

export async function searchVenues(q) {
  const { data } = await api.get("/venues/search", { params: { q } });
  return data.venues || [];
}

export async function requestVenue(name, email) {
  return api.post("/venues/request", {
    name,
    submitter_email: email || "",
    context: "gift_flow",
  });
}

export async function startGiftCheckout(body) {
  const { data } = await api.post("/gift/checkout-session", body);
  return data.checkoutUrl;
}
